import { extendTailwindMerge } from "tailwind-merge";
import { cx } from "tailwind-variants";
import { createTV } from "tailwind-variants";

const twMergeConfig = {
  extend: {
    theme: {
      radius: ["control", "card", "pill"],
      shadow: ["card", "popover", "modal"],
      spacing: [
        "page-margin",
        "card-padding",
        "section-gap",
        "content-gap",
        "inline-gap",
      ],
    },
    classGroups: {
      "font-size": [
        {
          text: [
            // Type roles from @konko-ai/tokens
            "display",
            "h1",
            "h2",
            "h3",
            "body",
            "body-sm",
            "caption",
            "label",
            // App-only static classes in src/index.css
            "headline",
            "title-1",
            "title-2",
            "title-3",
            "links",
            "subtext",
            "subtext-bold",
            "display1",
            "page-title",
          ],
        },
      ],
    },
  },
};

const twMerge = extendTailwindMerge(twMergeConfig);

export const tv = createTV({ twMergeConfig });

export const cn = (...inputs: Parameters<typeof cx>) => twMerge(cx(...inputs));
